import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Modal } from 'antd';
import { initEditorInformationsLinkModalData } from '../../../constans/controlToolbar';
import { addLink, editLink } from '../../../utils/changeEditorLinkFns';
import DropdownSelect from '../../../../dropdownSelect';

const ChangeEditorLinkModalNode = ({
  form,
  linkInformationModal,
  editor,
  appSectionsList = [],
}) => {
  const {
    getFieldDecorator,
    validateFieldsAndScroll,
    resetFields,
    getFieldValue,
    setFieldsValue,
  } = form;
  const { editorStateSelector, setEditorState } = editor;
  const { setEditorInformationLinkModalData, editorInformationLinkModalData } =
    linkInformationModal;

  const dispatch = useDispatch();
  const { visible, url, text, editMode, internalLinkId } =
    editorInformationLinkModalData;

  const editorState = useSelector(editorStateSelector);

  const handleCancel = () => {
    setEditorInformationLinkModalData(initEditorInformationsLinkModalData);
    resetFields();
  };

  const internalLinkValue = getFieldValue('internalLink');

  const handleOk = (e) => {
    e.preventDefault();
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { url, text } = values;

        const textToInsert = text && text.trim() !== '' ? text : url;

        const data = {
          editorState,
          textToInsert,
          url,
        };

        const newEditorState = editMode ? editLink(data) : addLink(data);

        dispatch(setEditorState(newEditorState));

        handleCancel();
      }
    });
  };

  const options = useMemo(
    () =>
      appSectionsList?.map((item) => ({
        ...item,
        value: item.id,
        content: item.description,
        key: item.id,
      })),
    [appSectionsList]
  );

  const getLinkValueById = (id) => {
    return appSectionsList?.find((item) => item.id === id);
  };

  useEffect(() => {
    if (internalLinkValue) {
      const value = getLinkValueById(internalLinkValue);
      setFieldsValue({
        url: `https://dispex.org/app/${value?.name}`,
      });
    }
  }, [internalLinkValue]);

  return (
    <Modal
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      destroyOnClose
    >
      <Form>
        <Form.Item
          label={editorState.getSelection().isCollapsed() ? 'Текст' : ''}
        >
          {getFieldDecorator('text', {
            initialValue: text || '',
            rules: [{ required: true, message: 'Пожалуйста, введите текст' }],
          })(
            <Input
              placeholder="Введите текст ссылки..."
              disabled={!editorState.getSelection().isCollapsed()}
              hidden={!editorState.getSelection().isCollapsed()}
            />
          )}
        </Form.Item>

        <Form.Item label="Раздел приложения">
          {getFieldDecorator('internalLink', {
            initialValue: internalLinkId || null,
            rules: [
              { required: true, message: 'Пожалуйста, выберите значение.' },
            ],
          })(
            <DropdownSelect
              options={options}
              multiple={false}
            />
          )}
        </Form.Item>
        {getFieldDecorator('url', {
          initialValue: url || 'https://dispex.org/app',
          rules: [{ required: true, message: 'Пожалуйста, введите URL.' }],
        })}
      </Form>
    </Modal>
  );
};

const ChangeEditorInformationsLinkModal = Form.create({
  name: 'change_editor_link',
})(ChangeEditorLinkModalNode);

export default ChangeEditorInformationsLinkModal;
